<template>
  <v-card flat>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text class="pa-0" v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>difficulty level</th>
              <th class="text-center">
                min
              </th>
              <th class="text-center">
                median
              </th>
              <th class="text-center">
                avg
              </th>
              <th class="text-center">
                max
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="value in info.time" :key="value.level">
              <td class="caption">{{ value.level }}</td>
              <td class="text-center caption">{{ timeToString(value.min * 1000) }}</td>
              <td class="text-center caption">{{ timeToString(value.median * 1000) }}</td>
              <td class="text-center caption">{{ timeToString(value.avg * 1000) }}</td>
              <td class="text-center caption">{{ timeToString(value.max * 1000) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Death count
              </th>
              <th class="text-left">
                Night Shade count
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="info.killers.length === 0">
              <td class="text-center caption" colspan="3">No data</td>
            </tr>
            <template v-else>
              <tr
                v-for="killer in info.killers"
                :key="killer.name"
              >
                <td class="caption">{{ killer.name }}</td>
                <td class="caption">{{ killer.death }}</td>
                <td class="caption">{{ killer.night_shade }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: true,
      info: {
        time: [],
        killers: []
      }
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-death-data`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.info = data
      }
      this.loading = false
    }
  }
}
</script>